import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import doctorActions from "../../../core/actions/doctorActions";
import MessageStrip from "../../../shared/messagestrip/MessageStrips";
import { format } from "date-fns";
import TextField from "@mui/material/TextField";
import { Grid, IconButton, InputAdornment } from "@mui/material";
import { List } from "@mui/material";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";
import { helperServices } from "../../../shared/helper";
import { Visibility } from "@material-ui/icons";
import { VisibilityOff } from "@mui/icons-material";

function AddStaff(props) {
  const dispatch = useDispatch();
  const org = useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);
  const [addFlag, setTextFlag] = useState(false);
  const [formErrors, setFormErrors] = useState({
    first_name: "",
    dob: "",
    phoneno: "",
    email: "",
    type: "",
    qualification: "",
    gender: "",
    password: "",
    confirmPassword: "",
  });
  const isEmail = (email) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const [staffDetail, setstaffDetail] = useState({
    id: "",
    patientId: "",
    first_name: "",
    mname: "",
    last_name: "",
    age: "",
    adhar: "",
    phoneno: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    gender: "",
    bloodgroup: "",
    occupation: "",
    address: "",
    dob: "",
    email: "",
    imgUrl: "",
    udt: "",
    type: "RegistrationDesk",
    qualification: "",
    visit: {},
    upload: {},
    password: "",
  });

  const [selectedGender, setSelectedGender] = useState("");
  const [showMsgStrip, setShowMsgStrip] = useState(false);
  const [messageDetails, setMessageDetails] = useState({});
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [roleList, setroleList] = useState([]);
  const [editPassword, setEditPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const noFormatFields = [
    "email",
    "bloodgroup",
    "type",
    "gender",
    "password",
    "confirmPassword",
  ];
  const [originalPhoneNo, setOriginalPhoneNo] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const handleInputChange = (name, value) => {
    if (name === "password" && !value) {
      setConfirmPassword("");
      setFormErrors((prev) => ({
        ...prev,
        confirmPassword: "",
      }));
    }

    setstaffDetail((prev) => ({
      ...prev,
      [name]: noFormatFields.includes(name) ? value : formatText(value),
    }));
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let errors = {};

    Object.keys(staffDetail).forEach((key) => {
      const error = validateField(key, staffDetail[key], true); // pass a flag to return errors
      if (error) {
        errors[key] = error;
      }
    });

    // Validate confirm password manually
    const confirmError = validateField(
      "confirmPassword",
      confirmPassword,
      true
    );
    if (confirmError) errors["confirmPassword"] = confirmError;

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      // no errors → safe to submit
      validateForm();
    }
  };

  useEffect(() => {
    // const servicesAllowed = helperServices.getServicesAllowed() || [];
    // console.log("Services allowed: ", servicesAllowed);
    // if (servicesAllowed.includes("EDIT_PASSWORD")) {
    //   setEditPassword(true);
    // }
    setEditPassword(helperServices.CheckAccessLevel("editPassword"));
  }, []);

  useEffect(() => {
    getRoleList();
    if (props.location && props.location.rowData) {
      let docData = props.location.rowData;
      setSelectedGender(docData.gender);
      setTextFlag(!addFlag);

      // Store the original phone number
      setOriginalPhoneNo(docData.phoneno || "");

      let date = new Date(docData.dob);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      docData.dob = `${yyyy}-${mm}-${dd}`;

      setstaffDetail(docData);
    } else {
      setTextFlag(addFlag);
      setOriginalPhoneNo(""); // Empty for add mode
    }
  }, []);

  const toggle = (event) => {
    props.history.push("/staffList");
  };

  const validateField = (fieldName, value, returnError = false) => {
    let error = "";

    const currentDate = new Date().toISOString().split("T")[0];

    switch (fieldName) {
      case "first_name":
        error = value ? "" : "Please Enter First Name";
        break;
      case "phoneno":
        if (!value) error = "Please Enter Phone Number";
        else if (value.length !== 10) error = "Please Enter Valid Phone Number";
        break;
      case "gender":
        error = value ? "" : "Please Select Gender";
        break;
      case "email":
        error = isEmail(value) ? "" : "Please Enter Valid Email";
        break;
      // case "password":
      //   if (addFlag === false || (addFlag && editPassword)) {
      //     error = value ? "" : "Please Enter Password";
      //   }
      //   break;
      // case "confirmPassword":
      //   if (addFlag === false || (addFlag && editPassword)) {
      //     if (!value) error = "Please Enter Confirm Password";
      //     else if (value != staffDetail.password)
      //       error = "Passwords do not match";
      //   }
      //   break;

      case "password":
        // Password is optional in edit mode
        if (!addFlag && value) {
          error = "";
        } else if (addFlag && editPassword && value) {
          error = "";
        }
        break;

      case "confirmPassword":
        // Validate only if password is entered
        if (staffDetail.password) {
          if (!value) {
            error = "Please Enter Confirm Password";
          } else if (value !== staffDetail.password) {
            error = "Passwords do not match";
          }
        }
        break;

      default:
        break;
    }

    if (returnError) return error;

    setFormErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const todayDate = format(
    new Date(Date.now() - 6570 * 24 * 60 * 60 * 1000),
    "yyyy-MM-dd"
  );

  const onSelectedGender = (value) => {
    setSelectedGender(value);
    handleInputChange("gender", value);
  };

  const closeAlert = () => {
    setServerRes({ success: "", error: "" });
  };

  const validateForm = (event) => {
    const payload = { ...staffDetail };
    if (!payload.gender) payload.gender = "Male";

    if (props.location && props.location.rowData) {
      payload.dob = new Date(payload.dob);
      dispatch(
        doctorActions.modifyDoctor(payload, (resCb) => {
          if (resCb.accresp?.success) {
            setServerRes({ success: "Staff updated Successfully" });
            setTimeout(() => {
              props.history.push("/staffList");
              closeAlert();
            }, 3000);
          } else if (resCb.accresp?.error) {
            console.log("resCb.accresp?.error", resCb.accresp?.error);
            setServerRes({ error: resCb.accresp?.error });
            setTimeout(() => {
              closeAlert();
            }, 3000);
          }
        })
      );
    } else {
      dispatch(
        doctorActions.saveDoctor(payload, (resCb) => {
          if (resCb.accresp?.success) {
            setServerRes({ success: "Staff added Successfully" });
            setTimeout(() => {
              props.history.push("/staffList");
              closeAlert();
            }, 3000);
          } else if (resCb.accresp?.error) {
            console.log("resCb.accresp?.error", resCb.accresp?.error);
            setServerRes({ error: resCb.accresp?.error });
            setTimeout(() => {
              closeAlert();
            }, 3000);
          }
        })
      );
    }
  };

  const getRoleList = () => {
    dispatch(
      doctorActions.getRoleList((resCb) => {
        if (resCb) {
          const filteredRoles = resCb.roleList
            .filter((role) => role.role.toLowerCase() !== "doctor")
            .map((role) => ({ id: role.id, role: role.role }));
          setroleList(filteredRoles);
        }
      })
    );
  };

  const closeMessageStrip = () => {
    setShowMsgStrip(false);
  };

  // Common input style
  const inputStyle = { height: "40px" };

  return (
    <>
      {showMsgStrip && (
        <MessageStrip
          msgStrip={messageDetails}
          closeMessageStrip={closeMessageStrip}
        />
      )}
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success}</Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error}</Alert>}

      <div className="insuranceFormContainer p-3">
        <h5>{addFlag ? "Edit" : "Add"} Staff</h5>
        <main className="mainsection">
          <List>
            <div className="p-2 bg-none">
              <form>
                {/* Row 1: Names */}
                <Grid container spacing={2} className="local-grid-override">
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="First Name"
                      value={staffDetail.first_name}
                      onChange={(e) =>
                        handleInputChange("first_name", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.first_name}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>

                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Middle Name"
                      value={staffDetail.mname}
                      onChange={(e) =>
                        handleInputChange("mname", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Last Name"
                      value={staffDetail.last_name}
                      onChange={(e) =>
                        handleInputChange("last_name", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                </Grid>

                {/* Row 2: Phone, Gender, DOB */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Phone Number"
                      type="number"
                      value={staffDetail.phoneno}
                      disabled={
                        props?.location?.rowData &&
                        originalPhoneNo &&
                        originalPhoneNo.toString().trim() !== ""
                      }
                      onChange={(e) => {
                        const val = e.target.value.slice(0, 10);
                        handleInputChange("phoneno", val);
                      }}
                      inputProps={{ maxLength: 10 }}
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.phoneno}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <RadioGroup
                      row
                      value={selectedGender}
                      onChange={(e) => onSelectedGender(e.target.value)}
                      sx={{ height: "40px", alignItems: "center" }}
                    >
                      <FormControlLabel
                        value="Male"
                        control={<Radio />}
                        label="Male"
                        sx={{ padding: 0 }}
                      />
                      <FormControlLabel
                        value="Female"
                        control={<Radio />}
                        label="Female"
                        sx={{ padding: 0 }}
                      />
                      <FormControlLabel
                        value="Others"
                        control={<Radio />}
                        label="Others"
                        sx={{ padding: 0 }}
                      />
                    </RadioGroup>
                    {formErrors.gender && (
                      <span
                        style={{
                          color: "#EC4147",
                          fontSize: "0.75rem",
                          marginLeft: "14px",
                        }}
                      >
                        {formErrors.gender}
                      </span>
                    )}
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      fullWidth
                      className="pt-2 py-2"
                      label="Date Of Birth"
                      type="date"
                      value={staffDetail.dob}
                      onChange={(e) => handleInputChange("dob", e.target.value)}
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.dob}
                        </span>
                      }
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ style: inputStyle }}
                      inputProps={{ max: todayDate }}
                    />
                  </Grid>
                </Grid>

                {/* Row 3: Blood Group, Qualification, Address */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <FormControl fullWidth className="pt-2 py-2">
                      <Select
                        displayEmpty
                        value={staffDetail.bloodgroup}
                        onChange={(e) =>
                          handleInputChange("bloodgroup", e.target.value)
                        }
                        sx={{
                          height: "40px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <MenuItem value="" disabled>
                          --Choose an option--
                        </MenuItem>
                        <MenuItem value="A +ve">A +ve</MenuItem>
                        <MenuItem value="A -ve">A -ve</MenuItem>
                        <MenuItem value="B +ve">B +ve</MenuItem>
                        <MenuItem value="B -ve">B -ve</MenuItem>
                        <MenuItem value="AB +ve">AB +ve</MenuItem>
                        <MenuItem value="AB -ve">AB -ve</MenuItem>
                        <MenuItem value="O +ve">O +ve</MenuItem>
                        <MenuItem value="O -ve">O -ve</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Qualification"
                      value={staffDetail.qualification}
                      onChange={(e) =>
                        handleInputChange("qualification", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.qualification}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Address"
                      value={staffDetail.address}
                      onChange={(e) =>
                        handleInputChange("address", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                </Grid>

                {/* Row 4: Email, City, State */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Email Id"
                      value={staffDetail.email}
                      disabled={!!props?.location?.rowData}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.email}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="City"
                      value={staffDetail.city}
                      onChange={(e) =>
                        handleInputChange("city", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="State"
                      value={staffDetail.state}
                      onChange={(e) =>
                        handleInputChange("state", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                </Grid>

                {/* Row 5: Pincode, Role */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="pt-2 py-2"
                      fullWidth
                      label="Pincode"
                      type="number"
                      value={staffDetail.pincode}
                      onChange={(e) =>
                        handleInputChange("pincode", e.target.value)
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <FormControl fullWidth className="pt-2 py-2">
                      <Select
                        value={staffDetail.type}
                        onChange={(e) =>
                          handleInputChange("type", e.target.value)
                        }
                        displayEmpty
                        sx={{
                          height: "40px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <MenuItem value="" disabled>
                          --Select Role--
                        </MenuItem>
                        {roleList.map((opt, idx) => (
                          <MenuItem key={idx} value={opt.role}>
                            {opt.role}
                          </MenuItem>
                        ))}
                      </Select>
                      {formErrors.type && (
                        <span
                          style={{
                            color: "#EC4147",
                            fontSize: "0.75rem",
                            marginLeft: "14px",
                          }}
                        >
                          {formErrors.type}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Row 8: Password */}
                {(addFlag === false || (addFlag && editPassword)) && (
                  <Grid
                    container
                    spacing={2}
                    sx={{ mt: 0 }}
                    className="local-grid-override"
                  >
                    <Grid item md={4}>
                      {/* <TextField
                        className="py-2"
                        fullWidth
                        type="password"
                        label={addFlag === false ? "Password" : "Edit password"}
                        value={staffDetail.password}
                        onChange={(e) =>
                          handleInputChange("password", e.target.value)
                        }
                        // error={!!formErrors.password}
                        helperText={
                          <span style={{ color: "#EC4147" }}>
                            {formErrors.password}
                          </span>
                        }
                        variant="outlined"
                        InputProps={{ style: inputStyle }}
                      /> */}
                      <TextField
                        className="py-2"
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        label={addFlag === false ? "Password" : "Edit password"}
                        value={staffDetail.password}
                        onChange={(e) =>
                          handleInputChange("password", e.target.value)
                        }
                        helperText={
                          <span style={{ color: "#EC4147" }}>
                            {formErrors.password}
                          </span>
                        }
                        variant="outlined"
                        InputProps={{
                          style: inputStyle,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                    </Grid>
                    <Grid item md={4}>
                      <TextField
                        className="py-2"
                        fullWidth
                        type={showConfirmPassword ? "text" : "password"}
                        label="Confirm password"
                        value={confirmPassword}
                        onChange={(e) =>
                          handleConfirmPasswordChange(e.target.value)
                        }
                        helperText={
                          <span style={{ color: "#EC4147" }}>
                            {formErrors.confirmPassword}
                          </span>
                        }
                        variant="outlined"
                        InputProps={{
                          style: inputStyle,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                                edge="end"
                              >
                                {showConfirmPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                    </Grid>
                  </Grid>
                )}

                {/* Buttons */}
                <div
                  className="buttonsetconfirm"
                  style={{
                    marginTop: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={toggle}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </List>
        </main>
      </div>
    </>
  );
}

export default AddStaff;
